import gql from 'graphql-tag';

export default {
  setOrderField: gql`
    mutation setOrderField($id: Int!, $name: String!, $value: String!) {
      setOrderField(id: $id, name: $name, value: $value)
    }
  `,
  checkOrderPaid: gql`
    query checkOrderPaid($id: Int!) {
      checkOrderPaid(id: $id)
    }
  `,
  getShareCart: gql`
    query getShareCart($cartToken: String!) {
      getShareCart(cartToken: $cartToken) {
        url
      }
    }
  `,
  createPayLink: gql`
    mutation createPayLink($id: Int!) {
      createPayLink(id: $id)
    }
  `,
  getSaleSectionProducts: gql`
    query getSaleSectionProducts($productsIds: [Float!]!) {
      getSaleSectionProducts(productsIds: $productsIds) {
        success
        productsIds
        info
        warning
        error
        errorCode
      }
    }
  `,
  addProductAfterPurchase: gql`
    mutation addProductAfterPurchase(
      $productId: Int!
      $orderId: Int!
      $quantity: Int
    ) {
      addProductAfterPurchase(
        productId: $productId
        orderId: $orderId
        quantity: $quantity
      ) {
        success
        info
        warning
        error
        errorCode
        orderItem {
          amount
          id
          price
          people_id
          ordersItems {
            catalog_id
            id
            weight
            item_weight
            price
            item_price
          }
        }
      }
    }
  `,
  getCommentsToOrder: gql`
    query getCommentList {
      getCommentList {
        id
        active
        attachment
        type
        title
        description
        placeholder
        required
        sort
        options {
          id
          comment
          active
          title
          sort
        }
      }
    }
  `,
  getOrderComments: gql`
    query getOrderComments($orderId: Int, $cartToken: String) {
      getOrderComments(orderId: $orderId, cartToken: $cartToken) {
        id
        type
        commentItems {
          value
          comment {
            id
            title
            type
            sort
            active
          }
          option {
            id
            title
            active
          }
        }
      }
    }
  `,
  getAddressComments: gql`
    query getAddressComments($addressId: Int!) {
      getAddressComments(addressId: $addressId) {
        id
        type
        commentItems {
          value
          comment {
            id
            type
            title
            active
            sort
          }
          option {
            id
            title
            active
          }
        }
      }
    }
  `,
  addCommentsToOrder: gql`
    mutation addCommentsToOrder($id: Int!, $comment: CommentsItemsInput!) {
      addCommentsToOrder(id: $id, comment: $comment)
    }
  `,
  addDefaultComment: gql`
    mutation addDefaultComment($comment: CommentsItemsInput!) {
      addDefaultComment(comment: $comment)
    }
  `,
  addCartComment: gql`
    mutation addCartComment(
      $comment: CommentsItemsInput!
      $cartToken: String!
    ) {
      addCartComment(comment: $comment, cartToken: $cartToken)
    }
  `,
  addCommentsToAdress: gql`
    mutation addCommentsToAdress($id: Int!, $comment: CommentsItemsInput!) {
      addCommentsToAdress(id: $id, comment: $comment)
    }
  `,
  addCommentsToOrderOrAddress: gql`
    mutation addCommentsToOrderOrAddress($data: CommentsUnionItemsInput!) {
      addCommentsToOrderOrAddress(data: $data)
    }
  `
};
